<app-modal-box [maxWidth]="modalMaxWidth" [allowOverflow]="true" [paddingValue]="'0'" [gapValue]="'0'">
  <div class="top">
    <div class="left">
      <div class="search input-group">
        <input type="text" placeholder="Search for items..." [(ngModel)]="search" (change)="onFilterChange()" />
        <app-icon class="search-icon" icon="loupe" [width]="16"></app-icon>
      </div>
      <div class="sort">
        <button class="sort-button" [toggleDropdown]="sortDropdown">
          {{ sortName[sort] }}
          <div class="arrow" [class.rotate]="sortDropdown.isCollapsed()">
            <app-icon [width]="20" [icon]="'arrow'"></app-icon>
          </div>
        </button>

        <app-dropdown class="sort-dropdown" (onItemSelect)="onSortChange($event)" #sortDropdown [width]="150">
          <app-dropdown-item [value]="'high-low'"> High - Low </app-dropdown-item>
          <app-dropdown-item [value]="'low-high'"> Low - High </app-dropdown-item>
          <!-- <app-dropdown-item [value]="'a-z'"> A - Z </app-dropdown-item>
          <app-dropdown-item [value]="'z-a'"> Z - A </app-dropdown-item> -->
        </app-dropdown>
      </div>
    </div>
    <div class="divider-vertical"></div>
    <div class="right">
      @if (depositType === 'join') {
      <div class="min-max">
        <div class="input-group left-label">
          <span class="label">From:</span>
          <app-icon class="icon" [width]="16" [icon]="'coin'"></app-icon>
          <input type="number" placeholder="From" [value]="coinflip.min_val" disabled />
        </div>
        <div class="divider-horizontal"></div>

        <div class="input-group left-label">
          <span class="label">To:</span>
          <app-icon class="icon" [width]="16" [icon]="'coin'"></app-icon>
          <input type="number" placeholder="To" [value]="coinflip.max_val" disabled />
        </div>
      </div>
      } @else {
      <div class="difference">
        <div class="difference-top">
          <div class="label">Join-Amount Difference</div>
          <div class="badge badge_black">{{ difference }}%</div>
        </div>
        <app-slider class="slider no-bg" [min]="10" [max]="20" [step]="1" [showValue]="false" [defaultValue]="15" [(value)]="difference" valueSmybol="%"></app-slider>
      </div>
      }
    </div>
  </div>
  <div class="middle stripes skins-shadow" [class.animation]="loading">
    @if(loading){
    <app-icon class="loading" [icon]="'refresh'" [width]="44"></app-icon>
    }
    <app-item-list
      class="list"
      [sort]="sort"
      [items]="items"
      [selectable]="true"
      [sort]="sort"
      [(selectedItems)]="selectedItems"
      (selectedValueChange)="selectedValue = $event"
      [virtualScrollScrollBar]="false"
      [virtualScroll]="true"
      [isItemEligible]="isItemEligible.bind(this)"
    ></app-item-list>
  </div>
  <div class="bottom">
    <div class="bottom-left">
      <button class="font-default-bold button green-third medium-2" (click)="refresh()" [class.loading]="loading">
        <app-icon [icon]="'refresh'" [width]="16"></app-icon>
        Refresh Inventory
      </button>
    </div>

    <div class="bottom-right">
      <div class="sides">
        <div
          class="side blue"
          [class.active]="coinflipService.coinSide === blueSide"
          [class.inactive]="coinflipService.coinSide !== blueSide || (depositType === 'join' && coinflip?.host?.side === blueSide)"
          (click)="pickSide(blueSide)"
          [class.disabled]="depositType === 'join' && coinflip?.host?.side === blueSide"
        >
          <app-coinflip-coin [size]="28" [side]="'blue'"></app-coinflip-coin>
        </div>

        <div
          class="side orange"
          [class.active]="coinflipService.coinSide === redSide"
          [class.inactive]="coinflipService.coinSide !== redSide || (depositType === 'join' && coinflip?.host?.side === redSide)"
          (click)="pickSide(redSide)"
          [class.disabled]="depositType === 'join' && coinflip?.host?.side === redSide"
        >
          <app-coinflip-coin [size]="28" [side]="'orange'"></app-coinflip-coin>
        </div>
      </div>
      <div class="divider-vertical"></div>
      @if (coinflip) {
      <button class="button black medium-2 font-default-bold" (click)="autoSelect()">Auto Select</button>
      }
      <!--  -->
      <button
        class="font-default-bold button green medium-2 deposit-button"
        [disabled]="depositType === 'join' ? selectedItems.length === 0 && (selectedValue < coinflip.min_val || selectedValue > coinflip.max_val) : selectedItems.length === 0"
        (click)="deposit()"
      >
        {{ depositType === 'join' ? 'Join' : 'Create' }} Game with
        <span>
          <app-icon icon="coin" [width]="16"></app-icon>
          {{ selectedValue | currency : 'USD' : '' : '1.2-2' }}
        </span>
      </button>
    </div>
  </div>
</app-modal-box>
